'use client';

import { InstallAlert } from '@/components/install-alert';

export default function InstallPrompt() {
    const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        !(window as any)?.MSStream;

    const isStandalone = window?.matchMedia(
        '(display-mode: standalone)',
    ).matches;

    if (isStandalone) {
        return null; // Don't show install button if already installed
    }

    return <InstallAlert show={isIOS} />;
}

